import React, { useContext, useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function EmploymentDetails({ formData }) {


  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);
 
  const [formDatas, setFormDatas] = useState({
    employer_name:  "",
    employer_address:  "",
    year_of_confirmation: "",
    gross_annual_income:  "",
    psn_ippis:  "",
    year_of_retirement:  "",
    net_monthly_income:  "",
    grade_level:  "",
    salary_payment_date:  "",
    employee_id:  "",
    qualification: "",
  });

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prev) => ({ ...prev, [name]: value }));
  };

  const validateField = (type, value) => {

    if (["gross_annual_income", "net_monthly_income"].includes(type)) {
      return /^\d+(\.\d{1,2})?$/.test(value.trim()); // number with optional decimals
    }
    if (type === "year_of_confirmation" || type === "year_of_retirement") {
      return /^\d{4}$/.test(value.trim()); // must be a valid 4-digit year
    }
    if (type === "salary_payment_date") {
      return /^\d{1,2}$/.test(value.trim()) && parseInt(value, 10) >= 1 && parseInt(value, 10) <= 31; // 1–31
    }
    return value.trim() !== "";
  };

  const handleSubmit = async (type) => {

    if (!validateField(type, formDatas[type])) {
      SoundAlert("error");
      toast.error("Please fill in this field correctly.");
      return;
    }

  


        const response = await Putrequest("auth/update_employment_details",{...formDatas,user_token:UserTokens})
   
               
                   if(response.status){

                    SoundAlert("success")
                    toast.success(response.textStatus)
                    setReloadBioForms(!ReloadBioForms)

               }




  };


  useEffect(()=>{
  
         setFormDatas({
              employer_name : formData.employment_details?.employer_name,
              employer_address : formData.employment_details?.employer_address,
              year_of_confirmation  : formData.employment_details?.year_of_confirmation,
              gross_annual_income  : formData.employment_details?.gross_annual_income,
              psn_ippis : formData.employment_details?.psn_ippis,
              year_of_retirement : formData.employment_details?.year_of_retirement,
              net_monthly_income  : formData.employment_details?.net_monthly_income,
              grade_level   : formData.employment_details?.grade_level,
              salary_payment_date  : formData.employment_details?.salary_payment_date,
              employee_id  : formData.employment_details?.employee_id,
              qualification  : formData.employment_details?.qualification,
         })
  
  },[formData])


  return (
    <div className="pt-2 pb-2">
      {/* Employer's Name */}
      <TextField
        label="Present Employer's Name"
        name="employer_name"
        value={formDatas.employer_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("employer_name")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Employer's Address */}
      <TextField
        label="Employer's Address"
        name="employer_address"
        value={formDatas.employer_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={2}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("employer_address")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Year of Confirmation */}
      <TextField
        label="Year of Confirmation"
        name="year_of_confirmation"
        value={formDatas.year_of_confirmation}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        placeholder="YYYY"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("year_of_confirmation")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Gross Annual Income */}
      <TextField
        label="Gross Annual Income (₦)"
        name="gross_annual_income"
        value={formDatas.gross_annual_income}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        type="number"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("gross_annual_income")}>
              Save
            </Button>
          ),
        }}
      />

      {/* PSN / IPPIS and Other Numbers */}
      <TextField
        label="PSN / IPPIS and Other Numbers"
        name="psn_ippis"
        value={formDatas.psn_ippis}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("psn_ippis")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Year of Retirement */}
      <TextField
        label="Year of Retirement"
        name="year_of_retirement"
        value={formDatas.year_of_retirement}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        placeholder="YYYY"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("year_of_retirement")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Net Monthly Income */}
      <TextField
        label="Net Monthly Income (₦)"
        name="net_monthly_income"
        value={formDatas.net_monthly_income}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        type="number"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("net_monthly_income")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Grade Level */}
      <TextField
        label="Grade Level"
        name="grade_level"
        value={formDatas.grade_level}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("grade_level")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Salary Payment Date */}
      <TextField
        label="Salary Payment Date (Day of Month)"
        name="salary_payment_date"
        value={formDatas.salary_payment_date}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        placeholder="1 - 31"
        type="number"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("salary_payment_date")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Employee ID */}
      <TextField
        label="Employee ID"
        name="employee_id"
        value={formDatas.employee_id}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("employee_id")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Qualification */}
      <TextField
        label="Qualification"
        name="qualification"
        value={formDatas.qualification}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("qualification")}>
              Save
            </Button>
          ),
        }}
      />
    </div>
  );
}

export default EmploymentDetails;
